module.exports = __webpack_public_path__ + "images/outside-tab.svg";